import { useState } from 'react';

import { type StudentSearch } from '~entities/student/modal/student-search';

import { StudentSelector } from '~features/students/ui/student-selector';

import { Button } from '~shared/shadcn/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~shared/shadcn/ui/dialog';

interface StudentSelectorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEnroll: (studentId: string) => void;
}

export const StudentSelectorDialog = ({
  open,
  onOpenChange,
  onEnroll,
}: StudentSelectorDialogProps) => {
  const [enrollmentStudent, setEnrollmentStudent] =
    useState<StudentSearch | null>(null);

  const onStudentSelectionChange = (
    value: StudentSearch | undefined | null,
  ) => {
    if (value) {
      setEnrollmentStudent(value);
    }
  };

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      setEnrollmentStudent(null);
    }
    onOpenChange(nextOpen);
  };

  return (
    // modal={false} + overflow-visible: menu stays under the field (no portal)
    // and option clicks remain usable inside the dialog.
    <Dialog modal={false} open={open} onOpenChange={handleOpenChange}>
      <DialogContent className='overflow-visible'>
        <DialogHeader>
          <DialogTitle>Select Student</DialogTitle>
          <DialogDescription>
            Select the student you want to add to the class.
          </DialogDescription>
        </DialogHeader>
        <StudentSelector
          className='w-full'
          onChange={onStudentSelectionChange}
        />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant='outline'>Cancel</Button>
          </DialogClose>
          <Button
            disabled={!enrollmentStudent}
            onClick={() => {
              onEnroll(enrollmentStudent?._id ?? '');
            }}
          >
            Enroll
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
